import styled from "styled-components";

const Content = styled.div`
  width: 100%;
  max-width: 335px;
  padding-right: 20px;
  padding-left: 20px;

  @media (max-width: 500px) {
    padding-top: 20px
    padding-right: 0;
    padding-bottom: 20px;
    padding-left: 0;
  }

  &,
  > h6 {
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: white;

    .theme--light & {
      color: black;
    }
  }

  > h6 {
    text-transform: uppercase;
    margin-bottom: 13px;
  }

  > p + p {
    margin-top: 7px;
  }

  > span {
    display: block;
    margin-top: 7px;
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: #5f5f5f;
  }
`

export default Content;
